import { StateCreator } from 'zustand'
import { AuthStore, AuthActions } from './types'

export const createAuthActions: StateCreator<AuthStore, [], [], AuthActions> = (
  set
) => ({
  setAuth: (user, authToken, refreshToken) =>
    set({ user, authToken, refreshToken }),
  updateTokens: (authToken, refreshToken) => set({ authToken, refreshToken }),
  updateUserCharityVehicleId: (vehicleId) =>
    set((state) => ({
      user: state.user
        ? { ...state.user, charity_vehicle_id: vehicleId }
        : null,
    })),
  clearAuth: () => set({ user: null, authToken: null, refreshToken: null }),
  setHasHydrated: (state) => set({ _hasHydrated: state }),
})
